import { useQueryState } from "nuqs";

export const useTablePagination = () => {
  const [page, setPage] = useQueryState("page", {
    defaultValue: 1,
    parse: (value) => Number.parseInt(value, 10),
    serialize: (value) => value.toString(),
    history: "replace",
  });
  const [limit, setLimit] = useQueryState("limit", {
    defaultValue: 50,
    parse: (value) => Number.parseInt(value, 10),
    serialize: (value) => value.toString(),
    history: "replace",
  });

  return { page, setPage, limit, setLimit };
};
